module.exports = __webpack_public_path__ + "static/media/5import-9.f3c73fca.xlsx";